let REGISTER_USER_ACCOUNT_OBJECT = {
   "id": "",  
   "firstName": "",
   "lastName": "",
   "email": "", 
   "conEmail": "",
   "password": "",
   "conPassword": "",
   "country": "",   
   "securityQuestion1": "",
   "securityAnswer1": "",
   "securityQuestion2": "",
   "securityAnswer2": "", 
   "securityQuestion3": "",
   "securityAnswer3": "",
};

export {REGISTER_USER_ACCOUNT_OBJECT};